import React from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';
import classnames from 'classnames';

import { StaticImage } from 'gatsby-plugin-image';
import { GlobalPageContext } from '../../types';

import * as styles from './NavigationBrand.module.scss';
import TopBarCTA from '../TopBarCTA/TopBarCTA';
import { WebsiteLocaleFragment } from '../../../graphql.schema';

type Props = {
  isOpen: boolean;
  onMenuToggle: (isOpen: boolean) => void;
  pathPrefixes: GlobalPageContext['pathPrefixes'];
  telephoneNumber: string;
  LocalesDropDown?: JSX.Element | null;
  websiteLocale: WebsiteLocaleFragment;
  websiteLocaleToV3: any;
};

const Brand = (props: Props) => {
  const data = useStaticQuery(graphql`
    query BrandQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <div className={classnames('navbar-brand is-flex is-justify-content-space-between', styles.root)}>
      <Link to={props.pathPrefixes.root} className="navbar-item">
      <StaticImage
          src="../../MOVEMETOCDN/wse-logo.webp"
          alt={data.site.siteMetadata.title}
          width={125}
          height={96}
          className={classnames('logo', styles.logo)}
        />
      </Link>
      <a
        className={classnames('is-hidden-tablet black-3 text-2', styles.telephoneText)}
        href={`tel:${props.telephoneNumber}`}
      >
        {props.telephoneNumber}
      </a>
      <div className={styles.localeContainer}>
        <div className='is-hidden-desktop'>
          <TopBarCTA websiteLocale={props.websiteLocale} cta={props.websiteLocaleToV3.topBarCta} />
        </div>
        {props.LocalesDropDown && <div className='is-hidden-tablet is-hidden-desktop locale-placeholder'>{props.LocalesDropDown}</div>}
        <a
          className={classnames('navbar-burger burger', styles.burger, {
            'is-active': props.isOpen,
          })}
          onClick={() => props.onMenuToggle(!props.isOpen)}
          role="button"
          aria-label="menu"
          aria-expanded={props.isOpen && 'true'}
        >
          <span aria-hidden="true" />
          <span aria-hidden="true" />
          <span aria-hidden="true" />
        </a>
      </div>
    </div>
  );
};

export default Brand;
